import { type FeatureFlagsInterface } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { FeatureFlagsActionTypes, type SetFeatureFlagsAction } from "~Shared/store/actions/featureFlags/featureFlagsTypes"

export const setFeatureFlags: ActionCreator<void> = (featureFlags: FeatureFlagsInterface) => (dispatch: Dispatch) => {
    const setFeatureFlagsAction: SetFeatureFlagsAction = {
        type: FeatureFlagsActionTypes.SET_FEATURE_FLAGS,
        featureFlags,
    }
    dispatch(setFeatureFlagsAction)
}
